// components/GlobalFloating.tsx
'use client';

import FloatingContact from './FloatingContact';
import FloatingAIBuilder from './FloatingAIBuilder';

export default function GlobalFloating() {
    return (
        <>
            {/* Left: WhatsApp + Call */}
            <FloatingContact />

            {/* Right: AI Builder → redirects to /ai-product-builder */}
            <FloatingAIBuilder />
        </>
    );
}